import type { Ops } from '@willie/schemas'

type CaptureOutcome = Ops.IndexCaptures.CaptureOutcome

/** What an operator has to decide, said as the cause rather than the symptom. */
export const outcomeLabel: Record<CaptureOutcome, string> = {
  match: 'Matched',
  mismatch: 'Index disagrees with telemetry',
  no_movement: 'Index did not move',
  decreasing: 'Index went backwards',
  no_reading: 'No confirmed reading',
  no_telemetry: 'Nothing to compare against',
  cannot_verify: 'Cannot be verified'
}

export const outcomeColor: Record<CaptureOutcome, 'green' | 'red' | 'amber' | 'gray'> = {
  match: 'green',
  mismatch: 'red',
  no_movement: 'red',
  decreasing: 'red',
  no_reading: 'amber',
  no_telemetry: 'gray',
  cannot_verify: 'gray'
}

type CaptureStatus = Ops.IndexCaptures.CaptureStatus

export const statusLabel: Record<CaptureStatus, string> = {
  pending: 'Not sent',
  sent: 'Awaiting photo',
  captured: 'Photo received',
  matched: 'Matched',
  flagged: 'Needs review',
  resolved: 'Resolved'
}

export const statusColor: Record<CaptureStatus, 'green' | 'red' | 'amber' | 'gray' | 'blue'> = {
  pending: 'amber',
  sent: 'blue',
  captured: 'blue',
  matched: 'green',
  flagged: 'red',
  resolved: 'gray'
}

export const roundLabel = (round: number | null): string => (round === null ? 'Ad-hoc' : String(round))
